import React, { useState } from 'react';
import { Redirect } from "react-router-dom";
import axios from 'axios';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Input,
  Label,
  Button,
  Table,
} from 'reactstrap';
import qs from 'query-string';
import authProtection from '../../HOCs/authProtection';
import { CLOUDINARY_THUMB } from '../../helpers/cloudinaryConstants';
import GNAddressFormat from '../../helpers/GNAddressFormat';
import LoaderSpinner from "../Widgets/LoaderSpinner";

import withAlertTimeout from '../../HOCs/withAlertTimeout';

const PoweredImages = props => {

  const [businessSearch, setBusinessSearch] = useState({
    businessName: '',
    businessCity: '',
    isSearching: false,
  });
  const [businessResults, setBusinessResults] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [redirectURL, setRedirectURL] = useState(null);

  const handleBusinessSearch = () => {

    setIsSubmitting(true);
    setBusinessSearch({
      ...businessSearch,
      isSearching: true,
    });
    const token = sessionStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    const query = {};
    if (businessSearch.businessName) {
      query.name = businessSearch.businessName;
    }

    if (businessSearch.businessCity) {
      query.geofence = businessSearch.businessCity;
    }

    // todo refactor out the isSearching: false's
    axios
      .get(`/api/proxy/v2/businesses?${qs.stringify(query)}`, headers)
      .then(({ data }) => {
        setBusinessResults(data.items);
        setIsSubmitting(false);
        setNoResults(!data.items.length)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        setBusinessSearch({
          ...businessSearch,
          isSearching: false,
        });
      });
  };

  const handleBusinessClick = id => {
    return () => {
        setRedirectURL(`/business/${id}/view-images`);
      };
  };

  const renderResults = () => {
    return businessResults.map(business => (
      <tr
        onClick={
          handleBusinessClick(business.id)
        }
        key={business.id}
        className='user-table__item'>
        <td className='text-center'>
          <div className='avatar'>
            <img
              src={`${CLOUDINARY_THUMB}/${business.avatar.image.cloudinaryId}`}
              className='img-avatar'
              alt={business.name}
            />
          </div>
        </td>
        <td className='text-center'>
          <div>{business.name}</div>
        </td>
        <td className='text-center'>
          <div> {GNAddressFormat(business.location.address)}</div>
        </td>
        <td className='text-center'>
          <div>{business.id}</div>
        </td>
      </tr>
    ));
  };

  if (redirectURL) {
    return <Redirect to={redirectURL} />;
  }

  return (

    <React.Fragment>
        <Card>
            <CardHeader>Search for a Business by Name</CardHeader>
            <CardBody>
                <FormGroup>
                <Label htmlFor='business name'>Business Name</Label>
                <Input
                    type='text'
                    name='businessName'
                    id='business-name-input'
                    placeholder='Enter Business Name'
                    value={businessSearch.businessName}
                    onChange={e =>
                    setBusinessSearch({
                        ...businessSearch,
                        [e.target.name]: e.target.value,
                    })
                    }
                />
                </FormGroup>
                <FormGroup>
                <Label htmlFor='business city'>Business City</Label>
                <Input
                    type='text'
                    name='businessCity'
                    id='business-city-input'
                    placeholder='Enter Business City'
                    value={businessSearch.businessCity}
                    onChange={e =>
                    setBusinessSearch({
                        ...businessSearch,
                        [e.target.name]: e.target.value,
                    })
                    }
                />
                </FormGroup>
                <Button color='primary' onClick={() => handleBusinessSearch()}>
                Search
                </Button>
            </CardBody>
            </Card>
            {isSubmitting && <LoaderSpinner />}
            {!isSubmitting && noResults && (
              <h4 style={{ textAlign: "center" }}>No Businesses Found</h4>
            )}
            {businessResults.length ? (
                <Table
                hover
                responsive
                className='table-outline mb-0 d-none d-sm-table user-table'>
                <thead className='thead-light'>
                    <tr>
                    <th className='text-center'>
                        <i className='icon-people' />
                    </th>
                    <th className='text-center'>Name</th>
                    <th className='text-center'>City/State</th>
                    <th className='text-center'>Business ID</th>
                    </tr>
                    {renderResults()}
                </thead>
                <tbody />
                </Table>
            ) : (
                ''
            )}
        
    </React.Fragment>
  );
  
};


export default authProtection(withAlertTimeout(PoweredImages));



// WEBPACK FOOTER //
// ./src/views/Pages/PoweredImages.js